module.exports = __webpack_public_path__ + "static/assets/0312e52099195f80d9cf1bc636b8e31b.svg";